﻿import './sections.css'
const TESTIMONIALS = [
  { quote: "The AI capabilities have transformed how we manage talent at scale. The results have exceeded our expectations.", name: 'Enterprise Technology Partner', title: 'Global Professional Services Firm', meta: 'Large-scale enterprise deployment' },
  { quote: "PossoBuild powers our enterprise learning and development platform. Their AI assessment capabilities validate training effectiveness at scale across thousands of learners. It's become a critical component of our talent development ecosystem.", name: 'Enterprise Learning Division', title: 'Global IT Services Leader • Fortune 100', meta: 'Serving 100,000+ corporate learners' },
  { quote: "We evaluated 12 AI hiring platforms. PossoBuild was the only one that understood enterprise scale and delivered on promised ROI. Our time-to-hire dropped 67% in the first quarter.", name: 'VP of Talent Acquisition', title: 'Technology Company • Series C', meta: '800 employees, 50+ hires per quarter' },
]
export default function TestimonialsSection() {
  return (
    <section className="testimonials-section section">
      <div className="container">
        <p className="section-eyebrow">CLIENT SUCCESS STORIES</p>
        <h2 className="section-title">Trusted by Global Leaders</h2>
        <p className="section-subtitle">See how enterprises are transforming talent management with PossoBuild</p>
        <div className="testimonials-grid">
          {TESTIMONIALS.map(t => (
            <div key={t.name} className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">{t.quote}</p>
              <div className="testimonial-author">
                <div className="author-name">{t.name}</div>
                <div className="author-title">{t.title}</div>
                <div className="author-meta">📊 {t.meta}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
